import CreateTransferActivityView from "@features/tools/view/transfer-activity-view/create-transfer-activity-view";

const CreateTransferActivity = () => {
  return <CreateTransferActivityView />;
};

export default CreateTransferActivity;
